import { Limit_Time_Period } from '@occc/graphql';

export const periodOptions = [
  { label: 'Daily', value: Limit_Time_Period.Day },
  { label: 'Weekly', value: Limit_Time_Period.Week },
  { label: 'Monthly', value: Limit_Time_Period.Month },
];
